import DashboardLegalAssistantLists from './DashboardLegalAssistantLists';

export default DashboardLegalAssistantLists;
